import type { BenefitDetailDto, BenefitGrantDto, BenefitWorkflowResponse, ServiceProviderPaymentDto } from "./benefit-types"
import { captureVendorPaymentContext, vendorPaymentContextCurrent, type VendorPaymentContext } from "./vendor-payment-context"

/** A removal confirmation retains its original target and prerequisites, not a saved-data cache. */
export type GrantRemoval = { context: VendorPaymentContext } & (
  { kind: "grant" } | { kind: "payment"; vendorId: number }
)

export function captureGrantRemoval(benefit: BenefitDetailDto, grant: BenefitGrantDto, workflow: BenefitWorkflowResponse | null,
  payment?: ServiceProviderPaymentDto): GrantRemoval | null {
  const context = captureVendorPaymentContext(benefit, grant, workflow)
  if (!context) return null
  if (!payment) return grant.serviceProviderPayments.length === 0 && !grant.certificationDate ? { kind: "grant", context } : null
  const matches = grant.serviceProviderPayments.filter(row => row.vendorId === payment.vendorId)
  return matches.length === 1 && JSON.stringify(matches[0]) === JSON.stringify(payment)
    ? { kind: "payment", vendorId: payment.vendorId, context } : null
}

export function grantRemovalCurrent(removal: GrantRemoval | null, benefit: BenefitDetailDto, workflow: BenefitWorkflowResponse | null): boolean {
  return !!removal && vendorPaymentContextCurrent(removal.context, benefit, workflow) && (removal.kind === "grant"
    ? removal.context.grant.serviceProviderPayments.length === 0 && !removal.context.grant.certificationDate
    : removal.context.grant.serviceProviderPayments.filter(payment => payment.vendorId === removal.vendorId).length === 1)
}

export function grantRemovalPath(removal: GrantRemoval): string {
  const { program, year } = removal.context.grant.benefitProgramInstance
  const grantPath = `/api/benefitapplications/${encodeURIComponent(removal.context.benefitId)}/grants/${program}/${year}`
  return removal.kind === "payment" ? `${grantPath}/vendor-payments/${removal.vendorId}` : grantPath
}
